import { Injectable } from '@angular/core';
import {CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {ChannelService} from '../channel.service';
import {SpinnerService} from '../../core/spinner/spinner.service';
import {RulesService} from '../rules.service';

@Injectable()
export class RuleEditGuard implements CanActivateChild {
  constructor(private channelService: ChannelService,
              private router: Router,
              private spinnerService: SpinnerService) {}
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (next.params.id !== 'edit')  {
        return true;
    }
    if (isNaN(next.params.ruleAppliesTo)) {
      this.router.navigate(['/rules/list']);
      return false;
    }
      this.spinnerService.show();
      return new Promise((resolve) => {
      this.channelService.getStatus(next.params.ruleAppliesTo)
        .then((res) => {
          this.spinnerService.hide();
          if (!res) {
            this.router.navigate(['/rules/list']);
          }
           resolve(res);
        })
        .catch(err => {
           this.spinnerService.hide();
          this.router.navigate(['/rules/list']);
          resolve(false);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/guards/rule-edit-guard.guard.ts